import React from 'react'

import Wrapper from './Wrapper'
import MessageUs from 'screens/Metabar/Support/MessageUs'

const InAppNotFound = () => (
  <Wrapper
    title={"We couldn't find the page you're looking for"}
    subtitle={
      <div className="center-text">
        Please verify you have the right link.
        <br />
        <MessageUs /> if this error persists
      </div>
    }
  />
)

export default InAppNotFound
